<template>
  <section class="ma-4 ma-md-8">
    <t-page-title title="Locais | Criação" />
    <v-row justify="center" align="center">
      <v-col>
        <v-card class="pa-8">
          <form-location v-model="model" @submit="($model: Local) => submit($model)" />
        </v-card>
      </v-col>
    </v-row>
  </section>
</template>

<script lang="ts" setup>
import { ref } from 'vue'
import TPageTitle from '@/components/TPageTitle.vue'
import FormLocation from './form-location.vue'
import Local from '@/types/Local'
import LocalService from '@/services/LocalService'
import { useLoader } from '@/stores/loader'
import { useSnackBar } from '@/stores/snackbar'
import { useRouter } from 'vue-router'
import { useProducerStore } from '@/stores/producer'

const loader = useLoader()
const snackbar = useSnackBar()
const router = useRouter()
const { producer } = useProducerStore()

const model = ref({
  name: '',
  active: true,
  address: '',
  number: '',
  complement: '',
  state: '',
  city: '',
  neighborhood: '',
  zip_code: '',
  producer_id: producer?.id,
} as Local)

async function submit(model: Local) {
  try {
    loader.increment()

    await (new LocalService()).store(model)

    snackbar.show(
      'Local criado com sucesso',
      'success',
    )

    router.push({ name: 'list-locations' })
  } finally {
    loader.decrement()
  }
}

</script>
